'use client';

import { GordonResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: GordonResult;
  translations: ToolsTranslations['gordon'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-xl font-semibold text-blue-900 mb-1">{translations.resultLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.price !== null ? `${result.price.toFixed(1)} kr` : '—'}</div>
      </div>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600">{result.message}</p>
      )}
    </div>
  );
}


